// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__1f8J5","title":"AfterImages90_title__3MZaH","images":"AfterImages90_images__1MKeo"};